// Version : 0.0.1
// Author : AGALYA
// LastEdit : SATHISH
// LastAdd : chanegs for code review correction
// MODFIED DATE:06-11-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET ALL ROLE LIST START *********************** */
export const allRoleListForCreditAppraisal = (listData: any) => {
	const data = {
		FetchAllRoleListForCreditAppraisalListToken: listData,
	};
	const url = `${API_URL}getAllRoleListForCreditAppraisal`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL ROLE LIST END *********************** */

/** ***************** ADD CREDIT APPRAISAL DETAILS START *********************** */
export const creditAppraisalDetailsAdd = (addData: any) => {
	const data = {
		AddCreditAppraisalToken: addData,
	};
	const url = `${API_URL}addCreditAppraisal`;
	return makeApiCall(url, data);
};
/** ***************** ADD CREDIT APPRAISAL DETAILS END *********************** */

/** ***************** GET ALL CREDIT APPRAISAL LIST START *********************** */
export const AllCreditAppraisalListGet = (listData: any) => {
	const data = {
		GetAllCreditAppraisalListToken: listData,
	};
	const url = `${API_URL}getAllCreditAppraisalList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL CREDIT APPRAISAL LIST END *********************** */

/** ***************** DELETE CREDIT APPRAISAL DETAILS START *********************** */
export const creditAppraisalDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteCreditAppraisalToken: deleteData,
	};
	const url = `${API_URL}deleteCreditAppraisal`;
	return makeApiCall(url, data);
};
/** ***************** DELETE CREDIT APPRAISAL DETAILS END *********************** */
